module.exports = __webpack_public_path__ + "assets/img/report-pp-btn-bg2.ac01e905.png";